/**
 * Shared job listing field options and search filter configs.
 * Used by EditListingDetailsForm, SectionJobDetails, JobListingCard, and SearchPage.
 */

export const POSITION_TYPE_OPTIONS = [
  { key: 'event_gig', labelId: 'EditListingDetailsForm.positionTypeEventGig' },
  { key: 'seasonal', labelId: 'EditListingDetailsForm.positionTypeSeasonal' },
  { key: 'temporary', labelId: 'EditListingDetailsForm.positionTypeTemporary' },
  { key: 'part_time', labelId: 'EditListingDetailsForm.positionTypePartTime' },
  { key: 'full_time', labelId: 'EditListingDetailsForm.positionTypeFullTime' },
  { key: 'permanent', labelId: 'EditListingDetailsForm.positionTypePermanent' },
];

/** Position types that show event date pickers */
export const EVENT_POSITION_TYPES = ['event_gig', 'seasonal', 'temporary'];

/** Position types that show the travel / applicant-location section */
export const TRAVEL_POSITION_TYPES = ['event_gig'];

export const EMPLOYMENT_TYPE_OPTIONS = [
  { key: 'employee_w2', labelId: 'EditListingDetailsForm.employmentTypeW2' },
  { key: 'contractor_1099', labelId: 'EditListingDetailsForm.employmentType1099' },
];

export const APPLICANT_LOCATION_OPTIONS = [
  { key: 'local_only', labelId: 'EditListingDetailsForm.applicantLocationLocalOnly' },
  { key: 'local_preferred', labelId: 'EditListingDetailsForm.applicantLocationLocalPreferred' },
  { key: 'open_to_all', labelId: 'EditListingDetailsForm.applicantLocationOpenToAll' },
];

export const TRAVEL_EXPENSE_OPTIONS = [
  { key: 'none', labelId: 'EditListingDetailsForm.travelExpenseNone' },
  { key: 'mileage', labelId: 'EditListingDetailsForm.travelExpenseMileage' },
  { key: 'airfare', labelId: 'EditListingDetailsForm.travelExpenseAirfare' },
  { key: 'hotel', labelId: 'EditListingDetailsForm.travelExpenseHotel' },
  { key: 'negotiable', labelId: 'EditListingDetailsForm.travelExpenseNegotiable' },
  { key: 'other', labelId: 'EditListingDetailsForm.travelExpenseOther' },
];

export const AMENITIES_PROVIDED_OPTIONS = [
  { key: 'hotel', labelId: 'EditListingDetailsForm.amenityHotel' },
  { key: 'meals', labelId: 'EditListingDetailsForm.amenityMeals' },
  { key: 'mileage', labelId: 'EditListingDetailsForm.amenityMileage' },
  { key: 'flight', labelId: 'EditListingDetailsForm.amenityFlight' },
  { key: 'rental_car', labelId: 'EditListingDetailsForm.amenityRentalCar' },
  { key: 'per_diem', labelId: 'EditListingDetailsForm.amenityPerDiem' },
];

/** Scalar / array publicData keys managed in code for job listings */
export const JOB_PUBLIC_DATA_KEYS = [
  'spots_required',
  'job_category',
  'position_type',
  'employment_type',
  'estimated_hours',
  'experience_required',
  'pay_type',
  'pay_min',
  'pay_max',
  'applicant_location_preference',
  'travel_expenses',
  'amenities_provided',
  'compensation_notes',
  // Optional detail fields
  'arrival_time',
  'end_time',
  'venue_name',
  'dress_code',
  'parking_instructions',
  'loading_dock_instructions',
  'floral_tools_provided',
  'additional_notes',
];

/**
 * Synthetic listing-field filter configs for the Jobs search tab.
 * These are injected client-side (not Console-hosted) so they appear as primary filters.
 */
export const getJobBoardFilterConfigs = intl => [
  {
    key: 'position_type',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: POSITION_TYPE_OPTIONS.map(o => ({
      option: o.key,
      label: intl.formatMessage({ id: o.labelId }),
    })),
    filterConfig: {
      indexForSearch: true,
      filterType: 'SelectSingleFilter',
      label: intl.formatMessage({ id: 'FilterComponent.positionTypeLabel' }),
      group: 'primary',
    },
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: ['job'],
    },
  },
  {
    key: 'employment_type',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: EMPLOYMENT_TYPE_OPTIONS.map(o => ({
      option: o.key,
      label: intl.formatMessage({ id: o.labelId }),
    })),
    filterConfig: {
      indexForSearch: true,
      filterType: 'SelectSingleFilter',
      label: intl.formatMessage({ id: 'FilterComponent.employmentTypeLabel' }),
      group: 'primary',
    },
    listingTypeConfig: {
      limitToListingTypeIds: true,
      listingTypeIds: ['job'],
    },
  },
];
